<template>
<div>
  <div class="wistia_embed wistia_async_lmmtz1vxqs">
    &nbsp;
  </div>

  <div
    id="how_open_is_too_open"
    class="tbk-vid-embed"
  >
    <a
      id="mark_aune"
      class="embedded_video"
      href="#wistia_m6vjl3r9nu?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="grace_gravelle"
      class="embedded_video"
      href="#wistia_gzzeaoaoa2?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('lmm', 12, this.showSelect)

    this.tbk.loadCrossTime('m6v', 261, this.showSelect)
    this.tbk.loadCrossTime('gzz', 99, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        m6v: this.tbk.autoPlay,
        gzz: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#how_open_is_too_open
  display: none
  a
    text-decoration: none
#mark_aune
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 100%
#grace_gravelle
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 100%
</style>

